<template>
    <div class="vodalys-bridge-instruction f-form">
        <FMiniTabs>
            <FMiniTab
                label="Vodalys Bridge connect"
                :selected="selectedTab === 'vodalys-bridge-connect'"
                @select="selectedTab = 'vodalys-bridge-connect'"
            />
            <FMiniTab
                label="Activate NDI® in Microsoft Teams"
                :selected="selectedTab === 'microsoft-teams'"
                @select="selectedTab = 'microsoft-teams'"
            />
            <FMiniTab
                label="NDI® network sources"
                :selected="selectedTab === 'ndi-network-sources'"
                @select="selectedTab = 'ndi-network-sources'"
            />
        </FMiniTabs>

        <FSexyScroll v-if="selectedTab === 'vodalys-bridge-connect'">
            <p>{{ $vt('With Vodalys Bridge, you can stream NDI® sources directly to vodalys.io.') }}</p>
            <p>
                <template v-if="downloadUrl">
                    <f-link :href="downloadUrl" blank>{{ $vt('Simply download and install') }}</f-link>
                </template>
                <template v-else>{{ $vt('Simply download and install') }}</template>
                {{ $vt('the Vodalys Bridge app on your computer to get started.') }}
            </p>
            <p>
                {{ $vt('Use') }}
                <template v-if="connectionUrl">
                    <f-link :href="connectionUrl">{{ $vt('the connection link') }}</f-link>
                </template>
                <template v-else>{{ $vt('the connection link') }}</template>
                {{ $vt('or copy the code to connect Vodalys Bridge to vodalys.io.') }}
            </p>

            <VForm17VodalysBridge
                :component="formComponent"
                @urls-change="handleUrlsChange"
            />

        </FSexyScroll>
        <FSexyScroll v-else-if="selectedTab === 'microsoft-teams'" class="vodalys-bridge-teams">
            <ol>
                <li>{{ $vt('Open Microsoft Teams and start a meeting or join one.') }}</li>
                <li>{{ $vt('Open the More actions menu (three dots), then select Live broadcast.') }}</li>
                <li>{{ $vt('In Live broadcast, select Broadcast over NDI®.') }}</li>
                <li>{{ $vt('Confirm the NDI® broadcast when prompted.') }}</li>
                <li>{{ $vt('In Vodalys Bridge, pick the NDI® source from Teams.') }}</li>
            </ol>
            <img :src="imageUrl" :alt="$vt('Microsoft Teams NDI® broadcast menu')" />
        </FSexyScroll>
        <FSexyScroll v-else class="vodalys-bridge-ndi">
            <p>{{ $vt('Vodalys Bridge lists NDI® sources available on your local network.') }}</p>
            <p>{{ $vt('Select a source and start broadcasting to vodalys.io.') }}</p>
            <p>{{ $vt('Make sure your computer and NDI® devices are on the same local network.') }}</p>
        </FSexyScroll>
    </div>
</template>
<script>

const imageUrl = new URL(
  './assets/microsoft_teams_capture.png',
  import.meta.url
);

export default {
    translate25Context: 'vodalys_bridge',
    props: {
        component: {
            type: Object,
            required: true
        }
    },
    computed: {
        formComponent() {
            return {
                download_url: this.component.download_url,
                connection_code: this.component.connection_code
            }
        }
    },
    data() {
        return {
            selectedTab: 'vodalys-bridge-connect',
            imageUrl,
            downloadUrl: null,
            connectionUrl: null
        };
    },
    methods: {
        handleUrlsChange({ connectionUrl, downloadUrl }) {
            this.connectionUrl = connectionUrl || null;
            this.downloadUrl = downloadUrl || null;
        }
    }
}
</script>
<style lang="scss">
.vodalys-bridge-instruction {
    .f-link {
        display: inline;
    }

    .f-sexy-scroll {
        .f-sexy-scroll-inner {
            padding: 20px;
        }
    }

    .vodalys-bridge-teams {
        h3 {
            margin: 0 0 12px 0;
        }

        ol {
            margin: 0 0 16px 18px;
            padding: 0;
        }

        img {
            max-width: 100%;
            height: auto;
            border-radius: 6px;
        }
    }
}
</style>